import weather from "@/util/weather";

export default {
  methods: {
    getIconFileName: function (icon) {
      return weather.getIconFileName(icon);
    },
  },
};
